"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LanguageGetByIdResponseSchema = exports.LanguageGetByIdResultSchema = exports.LanguageGetByIdSchema = exports.LanguageListResponseSchema = exports.LanguageListResultSchema = exports.LanguageListItemSchema = void 0;
const zod_1 = require("zod");
const schemas_1 = require("../../../../schemas");
const language_schema_1 = require("../../../../schemas/catalog/language.schema");
const LanguageBaseSchema = language_schema_1.LanguageSchema
    .extend({ certifications: language_schema_1.LanguageCertificationSchema.omit({ languageId: true }).array() });
exports.LanguageListItemSchema = LanguageBaseSchema;
exports.LanguageListResultSchema = zod_1.z.object({ languages: exports.LanguageListItemSchema.array() });
exports.LanguageListResponseSchema = (0, schemas_1.createSuccessResponseSchema)(exports.LanguageListResultSchema);
exports.LanguageGetByIdSchema = LanguageBaseSchema;
exports.LanguageGetByIdResultSchema = zod_1.z.object({ language: exports.LanguageGetByIdSchema });
exports.LanguageGetByIdResponseSchema = (0, schemas_1.createSuccessResponseSchema)(exports.LanguageGetByIdResultSchema);
